import { LOADING, SUCCEEDED, ERROR } from '@constants/fetchStatuses'
import { getToken } from '@auth/token-service'
import processError from '../helpers/processError'
import 'isomorphic-fetch'

/* global SERVER_BASE_URL */

export const FETCH_REPORT_SIGNATURE_REQUEST = 'FETCH_REPORT_SIGNATURE_REQUEST'
export const FETCH_REPORT_SIGNATURE_SUCCESS = 'FETCH_REPORT_SIGNATURE_SUCCESS'
export const FETCH_REPORT_SIGNATURE_FAILURE = 'FETCH_REPORT_SIGNATURE_FAILURE'
export const SAVE_REPORT_SIGNATURE_REQUEST = 'SAVE_REPORT_SIGNATURE_REQUEST'
export const SAVE_REPORT_SIGNATURE_SUCCESS = 'SAVE_REPORT_SIGNATURE_SUCCESS'
export const SAVE_REPORT_SIGNATURE_FAILURE = 'SAVE_REPORT_SIGNATURE_FAILURE'
export const DELETE_REPORT_SIGNATURE_REQUEST = 'DELETE_REPORT_SIGNATURE_REQUEST'
export const DELETE_REPORT_SIGNATURE_SUCCESS = 'DELETE_REPORT_SIGNATURE_SUCCESS'
export const DELETE_REPORT_SIGNATURE_FAILURE = 'DELETE_REPORT_SIGNATURE_FAILURE'

const fetchRequest = () => ({ type: FETCH_REPORT_SIGNATURE_REQUEST, status: LOADING })
const fetchSuccess = (data) => ({ type: FETCH_REPORT_SIGNATURE_SUCCESS, data, status: SUCCEEDED })
const fetchFailure = (errorMessage) => ({ type: FETCH_REPORT_SIGNATURE_FAILURE, errorMessage, status: ERROR })

const saveRequest = () => ({ type: SAVE_REPORT_SIGNATURE_REQUEST, status: LOADING })
const saveSuccess = (data) => ({ type: SAVE_REPORT_SIGNATURE_SUCCESS, data, status: SUCCEEDED })
const saveFailure = (errorMessage) => ({ type: SAVE_REPORT_SIGNATURE_FAILURE, errorMessage, status: ERROR })

const deleteRequest = () => ({ type: DELETE_REPORT_SIGNATURE_REQUEST, status: LOADING })
const deleteSuccess = () => ({ type: DELETE_REPORT_SIGNATURE_SUCCESS, status: SUCCEEDED })
const deleteFailure = (errorMessage) => ({ type: DELETE_REPORT_SIGNATURE_FAILURE, errorMessage, status: ERROR })

const SIGNATURE_URL_PATH = '/api/report-signature'

const authHeader = () => ({
  Authorization: `Bearer ${getToken()}`,
})

const jsonHeaders = () => ({
  ...authHeader(),
  'content-type': 'application/json',
  accept: 'application/json',
})

export function fetchReportSignature() {
  return (dispatch) => {
    dispatch(fetchRequest())
    return fetch(`${SERVER_BASE_URL}${SIGNATURE_URL_PATH}`, {
      method: 'GET',
      headers: jsonHeaders(),
    })
      .then((response) => response.json().catch(() => ({})).then((result) => ({ result, response })))
      .then(({ result, response }) => {
        if (!response.ok) {
          dispatch(fetchFailure(processError(result)))
          return Promise.reject(result)
        }
        dispatch(fetchSuccess(result))
        return result
      })
  }
}

export function uploadReportSignature(file) {
  const form = new FormData()
  form.set('signature_file', file, file.name)
  return (dispatch) => {
    dispatch(saveRequest())
    return fetch(`${SERVER_BASE_URL}${SIGNATURE_URL_PATH}`, {
      method: 'POST',
      headers: authHeader(),
      body: form,
    })
      .then((response) => response.json().catch(() => ({})).then((result) => ({ result, response })))
      .then(({ result, response }) => {
        if (!response.ok) {
          dispatch(saveFailure(processError(result)))
          return Promise.reject(result)
        }
        dispatch(saveSuccess(result))
        return result
      })
  }
}

export function generateReportSignature() {
  return (dispatch) => {
    dispatch(saveRequest())
    return fetch(`${SERVER_BASE_URL}${SIGNATURE_URL_PATH}/generate`, {
      method: 'POST',
      headers: jsonHeaders(),
    })
      .then((response) => response.json().catch(() => ({})).then((result) => ({ result, response })))
      .then(({ result, response }) => {
        if (!response.ok) {
          dispatch(saveFailure(processError(result)))
          return Promise.reject(result)
        }
        dispatch(saveSuccess(result))
        return result
      })
  }
}

export function deleteReportSignature() {
  return (dispatch) => {
    dispatch(deleteRequest())
    return fetch(`${SERVER_BASE_URL}${SIGNATURE_URL_PATH}`, {
      method: 'DELETE',
      headers: jsonHeaders(),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().catch(() => ({})).then((result) => {
            dispatch(deleteFailure(processError(result)))
            return Promise.reject(result)
          })
        }
        dispatch(deleteSuccess())
        return null
      })
  }
}
